export default "__VITE_ASSET__CWEjP4bZ__"